// Mock config for local development support chat
import { ChatUser } from './chat.service';

export const MOCK_SUPPORT_USER: ChatUser = {
  id: 'mock-user',
  name: 'Mock User',
  image: '/assets/images/pipa_headshot.png',
};

export const MOCK_SUPPORT_MESSAGES = [
  {
    id: 1,
    user: 'support',
    text: 'Hi! How can we help you today?',
    createdAt: new Date(),
  },
  {
    id: 2,
    user: 'mock-user',
    text: 'I have a question about my account.',
    createdAt: new Date(),
  },
];
